import { useEffect, useRef } from 'react'

const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'

export const useFocusTrap = <T extends HTMLElement>() => {
    const ref = useRef<T>(null)

    useEffect(() => {
        const el = ref.current
        if (!el) return

        const previouslyFocused = document.activeElement as HTMLElement | null

        // Focus the first focusable element inside the modal
        const firstFocusable = el.querySelector<HTMLElement>(FOCUSABLE)
        firstFocusable?.focus()

        const handleKeyDown = (e: KeyboardEvent) => {
            if (e.key !== 'Tab') return

            const focusable = Array.from(el.querySelectorAll<HTMLElement>(FOCUSABLE))
            if (focusable.length === 0) return

            const first = focusable[0]
            const last = focusable[focusable.length - 1]

            if (e.shiftKey) {
                if (document.activeElement === first) {
                    e.preventDefault()
                    last.focus()
                }
            } else {
                if (document.activeElement === last) {
                    e.preventDefault()
                    first.focus()
                }
            }
        }

        document.addEventListener('keydown', handleKeyDown)
        return () => {
            document.removeEventListener('keydown', handleKeyDown)
            previouslyFocused?.focus()
        }
    }, [])

    return ref
}
